import React, { useState } from 'react';
import './App.css';

import StatsController from './controller/controller.stats'
import NavBar from './hooks/commonHooks/commonHooks.navBar';

const App = () => {

  const [logsStored, setLogsStored] = useState(null);

  const getData = async () => {
    const response = await StatsController.getNumberOfLogs()
    const data = response.data;
    setLogsStored(data.entityCount + data.encounterCount)
  }

  getData()

  return (
    <div className="app-container">
      <NavBar />
      <main className="main-content">
        <h1 className="main-title">
          LOST ARK <span className="underline">LOGS</span><br />
          UPLOADER
        </h1>
          <p className="logs-stored">Over {logsStored} logs stored</p>
        <div className="button-container">
          <a href="/signup" className="get-started-btn">Get Started</a>
          <a href="/leaderboard" className="get-started-btn" style={{ marginLeft: '10px' }}>View As Guest</a>
        </div>
      </main>
    </div>
  );
};

export default App;